import {useCallback, useState} from 'react';

export function useSelection() {
  const [selectedItems, setSelectedItems] = useState<any[]>([]);

  const toggle = useCallback((item: any) => {
    setSelectedItems(prev => {
      const exists = prev.find(i => i.id === item.id);

      if (exists) {
        return prev.filter(k => k.id !== item.id);
      }

      return [...prev, item];
    });
  }, []);

  const clear = useCallback(() => {
    setSelectedItems([]);
  }, []);

  const selectAll = useCallback((ids: string[]) => {
    setSelectedItems(ids);
  }, []);

  return {
    selectedItems,
    toggle,
    clear,
    selectAll
  };
}
